import { useDecision } from '@optimizely/react-sdk'

export const BASKET_UPSELL_FLAG = 'turnips_ofx_rth_basket_upsell'

export const useBasketUpsellFeatureFlag = () => {
  const [decision] = useDecision(BASKET_UPSELL_FLAG)

  return decision.variationKey === 't1'
}
